import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';
import { AppModuleShared } from './app.module.shared';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material';
import { NumPadComponent } from './shared/common/num-pad/num-pad.component';
import { CalculatorPopupService } from './core/calculator-popup.service';

@NgModule({
  declarations: [NumPadComponent],
  imports: [
    BrowserAnimationsModule,
    MatSliderModule,
    BrowserModule,
    HttpClientModule,
    CoreModule,
    AppModuleShared
  ],
  providers: [CalculatorPopupService],
  bootstrap: [AppComponent],
  entryComponents: [NumPadComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts